/** SouthIndianTradition — Programme. Ceremony timeline with events. */

import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, Clock, MapPin } from 'lucide-react';
import { SOUTH_INDIA_EASE } from '../theme';
import type { SouthIndianContent } from '../content';

export function ProgrammeSection({ content }: { content: SouthIndianContent['ceremony'] }) {
  return (
    <section className="px-6 py-16" style={{ background: '#fdf9f0', color: '#1f1103' }}>
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: SOUTH_INDIA_EASE }}
        className="text-center text-sm uppercase tracking-[0.3em]"
        style={{ color: '#843c3a' }}
      >
        {content.label}
      </motion.p>
      <h2 className="mt-2 text-center font-serif text-4xl font-semibold" style={{ color: '#843c3a' }}>
        {content.title}
      </h2>

      <div className="mx-auto mt-10 grid max-w-4xl gap-6">
        {content.events.map((event, i) => (
          <motion.div
            key={event.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: SOUTH_INDIA_EASE }}
            className="flex flex-col gap-4 rounded-2xl border p-6 sm:flex-row sm:items-center"
            style={{ borderColor: 'rgba(132, 60, 58, 0.12)', background: 'white' }}
          >
            {event.image && (
              <img
                src={event.image}
                alt={event.title}
                className="h-32 w-full rounded-xl object-cover sm:w-32"
              />
            )}
            <div className="flex-1">
              <h3 className="font-serif text-2xl" style={{ color: '#843c3a' }}>
                {event.title}
              </h3>
              <p className="mt-2 text-sm" style={{ color: '#634f41' }}>
                {event.description}
              </p>
              <div className="mt-3 flex flex-wrap gap-4 text-sm" style={{ color: '#843c3a' }}>
                <span className="inline-flex items-center gap-1">
                  <CalendarDays className="h-4 w-4" /> {event.date}
                </span>
                <span className="inline-flex items-center gap-1">
                  <Clock className="h-4 w-4" /> {event.time}
                </span>
                <span className="inline-flex items-center gap-1">
                  <MapPin className="h-4 w-4" /> {event.venue}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
